// @flow
/**
 * Cricket Team Selection Logic
 * Batsman ->
 *        Min : 3
 *        Max : 6
 * Bowler ->
 *        Min : 3
 *        Max : 6
 * AllRounders ->
 *        Min : 1
 *        Max : 4
 * WK ->
 *      Min : 1
 *      Max : 4
 *
 * and maximum 7 players from the one team
 */

import './index_mWeb.css';
import React, { useRef } from 'react';
import { HeaderWithTimer, RouteWrapper, View } from '../../../component';
import { useLink } from 'react-router-stack';
import { useDispatch, useSelector } from 'react-redux';
import useGame from '../../../utilities/hooks/game';
import { CreateTeamBottomContainer } from '../../component';
import SwipeableViews from 'react-swipeable-views';
import CreateTeamTabBarMWeb from '../../component/create_team_tab_bar/index_mWeb';
import CreateTeamHeaderMWeb from '../../component/create_team_header/index_mWeb';
import CreateTeamTabContentMWeb from '../../component/create_team_tab_content/index_mWeb';
import constants from '../../../constants';
import GuideTour from '../../../component/guide_tour';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const CreateTeamMWeb = ({
  teamA,
  teamAPlayersCount,
  teamB,
  teamBPlayersCount,
  matchItem,
  keeperList,
  batsmanList,
  allRounderList,
  bowlerList,
  sortName,
  sortType,
  onUpdateSortingList,
  activeTab,
  onPressPlayer,
  renderWhenEmpty,
  lineupsOut,
  keeperListDisable,
  batsmanListDisable,
  allRounderListDisable,
  bowlerListDisable,
  totalCreditCount,
  counts,
  onPressPlayerMinus,
  onChangeTab,
  routes,
  onPressTeamPreview,
  onPressContinue,
  setActiveTab,
  teamNumber
}: any) => {
  const navigate = useLink();
  const dispatch = useDispatch();
  const { teamName } = useSelector((state: any) => state.user);

  const { fantasyMatchClick } = useGame();

  const isTabClicked = useRef(false);

  const {
    entryFee,
    contestId,

    joinedMatch,

    isFromMyTeam = false
  } = matchItem;

  const onCalledDeadline = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onPressBack = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: isFromMyTeam ? joinedMatch : false,
          contestId: isFromMyTeam ? contestId : '',
          entryFee: isFromMyTeam ? entryFee : '',
          isTeamSwitch: false,
          myContestJoinedTeams: [],
          contestType: {},
          isFromCreateTeamButton: false
        }
      })
    );
    // navigation.pop(1);
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
    return true;
  };
  const activeTabTemp = useRef(0);

  const handleOnChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    isTabClicked.current = true;
    onChangeTab(_event, activeTab);
  };

  const onChangeTabIndex = (index = 0) => {
    activeTabTemp.current = index;
  };
  const onTransitionEnd = () => {
    if (!isTabClicked.current) {
      setActiveTab(activeTabTemp.current);
    }
    isTabClicked.current = false;
  };
  const isGuideTourCompleted =
    localStorage.getItem(constants.GuideTour['create_team_mWeb'].key) === 'true';
  const userName = `${teamName} (T${teamNumber})`;
  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        {!isGuideTourCompleted && (
          <GuideTour
            steps={constants.GuideTour['create_team_mWeb'].steps}
            keyValue={constants.GuideTour['create_team_mWeb'].key}
            elementId={'create_team_mWeb'}
          />
        )}
        <div className="create_team_wrapper_mWeb" id="create_team_mWeb">
          <HeaderWithTimer
            onlyTimer={true}
            onPressBack={onPressBack}
            matchItem={matchItem}
            onCalledDeadline={onCalledDeadline}
            teamName={userName}
          />
          <CreateTeamHeaderMWeb
            counts={counts}
            teamACount={teamAPlayersCount}
            teamBCount={teamBPlayersCount}
            totalCreditCount={totalCreditCount}
            teamAName={teamA?.shortName}
            teamBName={teamB?.shortName}
            onPressPlayerMinus={onPressPlayerMinus}
          />
          <View className={'create-team-container_mWeb'}>
            <View className="create_team_tab_bar_contianer_mWeb">
              <CreateTeamTabBarMWeb
                onChangeTab={handleOnChangeTab}
                activeTab={activeTab}
                counts={counts}
                routes={routes}
              />
            </View>
            <div className="flat-list-outer-grow">
              <SwipeableViews
                className={'create-team-swipeable-view_mWeb'}
                index={activeTab}
                onChangeIndex={onChangeTabIndex}
                onTransitionEnd={onTransitionEnd}>
                <View className="create-team-tab_mWeb">
                  <CreateTeamTabContentMWeb
                    data={keeperList}
                    matchItem={matchItem}
                    onPressPlayer={onPressPlayer}
                    selectedTab={activeTab}
                    renderWhenEmpty={renderWhenEmpty}
                    keeperList={keeperList}
                    batsmanList={batsmanList}
                    allRounderList={allRounderList}
                    bowlerList={bowlerList}
                    lineupsOut={lineupsOut}
                    keeperListDisable={keeperListDisable}
                    batsmanListDisable={batsmanListDisable}
                    allRounderListDisable={allRounderListDisable}
                    bowlerListDisable={bowlerListDisable}
                    teamAPlayersCount={teamAPlayersCount}
                    teamBPlayersCount={teamBPlayersCount}
                    totalCreditCount={totalCreditCount}
                    onUpdateSortingList={onUpdateSortingList}
                    sortName={sortName}
                    sortType={sortType}
                  />
                  {/* )} */}
                </View>
                <View className="create-team-tab_mWeb">
                  <CreateTeamTabContentMWeb
                    data={batsmanList}
                    matchItem={matchItem}
                    onPressPlayer={onPressPlayer}
                    selectedTab={activeTab}
                    renderWhenEmpty={renderWhenEmpty}
                    keeperList={keeperList}
                    batsmanList={batsmanList}
                    allRounderList={allRounderList}
                    bowlerList={bowlerList}
                    lineupsOut={lineupsOut}
                    keeperListDisable={keeperListDisable}
                    batsmanListDisable={batsmanListDisable}
                    allRounderListDisable={allRounderListDisable}
                    bowlerListDisable={bowlerListDisable}
                    teamAPlayersCount={teamAPlayersCount}
                    teamBPlayersCount={teamBPlayersCount}
                    totalCreditCount={totalCreditCount}
                    onUpdateSortingList={onUpdateSortingList}
                    sortName={sortName}
                    sortType={sortType}
                  />
                  {/* )} */}
                </View>
                <View className="create-team-tab_mWeb">
                  <CreateTeamTabContentMWeb
                    data={allRounderList}
                    matchItem={matchItem}
                    onPressPlayer={onPressPlayer}
                    selectedTab={activeTab}
                    renderWhenEmpty={renderWhenEmpty}
                    keeperList={keeperList}
                    batsmanList={batsmanList}
                    allRounderList={allRounderList}
                    bowlerList={bowlerList}
                    lineupsOut={lineupsOut}
                    keeperListDisable={keeperListDisable}
                    batsmanListDisable={batsmanListDisable}
                    allRounderListDisable={allRounderListDisable}
                    bowlerListDisable={bowlerListDisable}
                    teamAPlayersCount={teamAPlayersCount}
                    teamBPlayersCount={teamBPlayersCount}
                    totalCreditCount={totalCreditCount}
                    onUpdateSortingList={onUpdateSortingList}
                    sortName={sortName}
                    sortType={sortType}
                  />
                </View>
                <View className="create-team-tab_mWeb">
                  <CreateTeamTabContentMWeb
                    data={bowlerList}
                    matchItem={matchItem}
                    onPressPlayer={onPressPlayer}
                    selectedTab={activeTab}
                    renderWhenEmpty={renderWhenEmpty}
                    keeperList={keeperList}
                    batsmanList={batsmanList}
                    allRounderList={allRounderList}
                    bowlerList={bowlerList}
                    lineupsOut={lineupsOut}
                    keeperListDisable={keeperListDisable}
                    batsmanListDisable={batsmanListDisable}
                    allRounderListDisable={allRounderListDisable}
                    bowlerListDisable={bowlerListDisable}
                    teamAPlayersCount={teamAPlayersCount}
                    teamBPlayersCount={teamBPlayersCount}
                    totalCreditCount={totalCreditCount}
                    onUpdateSortingList={onUpdateSortingList}
                    sortName={sortName}
                    sortType={sortType}
                  />
                </View>
              </SwipeableViews>
            </div>
            <CreateTeamBottomContainer
              onPressTeamPreview={onPressTeamPreview}
              onPressContinue={onPressContinue}
            />
          </View>
        </div>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default CreateTeamMWeb;
